'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getAcceptedMIMES;
var _MIMES = require("Shared/MIMES");
function getAcceptedMIMES(props) {
  const list = [],
    extensions = [];
  Object.keys(_MIMES.MIMES_extensions).filter(function (MIME) {
    if (props.accept.includes('image') && MIME.startsWith('image/')) {
      return true;
    }
    if (props.accept.includes('text') && MIME.startsWith('text/')) {
      return true;
    }
    if (props.accept.includes('pdf') && MIME === 'application/pdf') {
      return true;
    }
    if (props.accept.includes('zip') && MIME.includes('zip')) {
      return true;
    }
    if (props.accept.includes('video') && MIME.startsWith('video/')) {
      return true;
    }
    if (props.accept.includes('audio') && MIME.startsWith('audio/')) {
      return true;
    }
    if (props.accept.includes('dicom') && MIME.startsWith('application/dicom')) {
      return true;
    }
  }).forEach(function (MIME) {
    list.push(MIME);
    if (extensions.includes(_MIMES.MIMES_extensions[MIME]) === false) {
      extensions.push(_MIMES.MIMES_extensions[MIME]);
    }
  });
  return {
    accepted_MIMES: list,
    accepted_extensions: extensions
  };
}
